import React from 'react';
import RefundStatus from '../components/RefundStatus';

export default function RefundStatusPage() {
  return (
    <div className="pt-4">
      <RefundStatus />
    </div>
  );
}